module.exports = __webpack_public_path__ + "img/nieuwbouw.c02221b4.png";